import { appWillStart$ } from '@shopgate/pwa-common/streams';
import initMeta from '../actions/initMeta';

export default (subscribe) => {
  subscribe(appWillStart$, ({ dispatch }) => {
    dispatch(initMeta());
  });
};
